import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.automation.marketingContacts.disableModal.${key}`;
const Header = ({
  formName
}) => /*#__PURE__*/_jsx(DialogHeader, {
  children: /*#__PURE__*/_jsx(Text, {
    as: "h2",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('header'),
      options: {
        formName
      }
    })
  })
});
const Body = () => /*#__PURE__*/_jsx(DialogBody, {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey('body')
  })
});
const Footer = ({
  onConfirm,
  onCancel
}) => /*#__PURE__*/_jsxs(DialogFooter, {
  children: [/*#__PURE__*/_jsx(Button, {
    use: "danger",
    onClick: onConfirm,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('confirm')
    })
  }), /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    onClick: onCancel,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cancel"
    })
  })]
});
const MarketableContactsWarningModal = ({
  formName,
  onConfirm,
  onCancel
}) => /*#__PURE__*/_jsxs(Modal, {
  use: "danger",
  width: 550,
  children: [/*#__PURE__*/_jsx(Header, {
    formName: formName
  }), /*#__PURE__*/_jsx(Body, {}), /*#__PURE__*/_jsx(Footer, {
    onConfirm: onConfirm,
    onCancel: onCancel
  })]
});
export default MarketableContactsWarningModal;